module.exports = __webpack_public_path__ + "officialStatic/img/detail-one3.10e89de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-one3.png
// module id = kiJN
// module chunks = 0